var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenseComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 111,
    viewBox: "0 0 112 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1305 34.084C100.866 34.084 102.273 35.4911 102.273 37.2268V79.4507C102.273 85.3836 97.4368 90.3666 91.3575 90.3666H25.5266C23.7909 90.3666 22.3838 88.9595 22.3838 87.2238C22.3838 85.488 23.7909 84.0809 25.5266 84.0809H91.3575C93.9149 84.0809 95.9877 81.9626 95.9877 79.4507V37.2268C95.9877 35.4911 97.3948 34.084 99.1305 34.084Z",
    fill: "#D2E5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.112 85.784C16.4098 85.784 12.5713 81.9455 12.5713 77.2433V46.8229V32.8122C12.5713 28.11 16.4098 24.2715 21.112 24.2715H28.8851H89.0541C93.7563 24.2715 97.5948 28.11 97.5948 32.8122V77.1473C97.5948 81.8495 93.7563 85.688 89.0541 85.688H21.112V85.784Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1123 25.685C17.1911 25.685 13.9858 28.8904 13.9858 32.8115V77.2425C13.9858 80.7667 16.575 83.7126 19.946 84.273H89.0543C92.9754 84.273 96.1808 81.0677 96.1808 77.1465V32.8115C96.1808 28.8904 92.9754 25.685 89.0543 25.685H21.1123ZM22.5265 87.1016H89.0543C94.5376 87.1016 99.0093 82.6298 99.0093 77.1465V32.8115C99.0093 27.3282 94.5376 22.8564 89.0543 22.8564H21.1123C15.629 22.8564 11.1572 27.3282 11.1572 32.8115V77.2425C11.1572 82.7258 15.629 87.1975 21.1123 87.1975H22.5265V87.1016Z",
    fill: "#3694E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 71.1886C24.4355 70.3207 25.1391 69.6172 26.007 69.6172H45.9674C46.8352 69.6172 47.5388 70.3207 47.5388 71.1886C47.5388 72.0565 46.8352 72.76 45.9674 72.76H26.007C25.1391 72.76 24.4355 72.0565 24.4355 71.1886Z",
    fill: "#DEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 55.1886C24.4355 54.3207 25.1391 53.6172 26.007 53.6172H83.4022C84.2701 53.6172 84.9736 54.3207 84.9736 55.1886C84.9736 56.0565 84.2701 56.76 83.4022 56.76H26.007C25.1391 56.76 24.4355 56.0565 24.4355 55.1886Z",
    fill: "#DEE9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 67.6172H82V73.6172H85V67.6172Z",
    fill: "#DEE9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67.6172H56V73.6172H58V67.6172Z",
    fill: "#DEE9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67.6172H59V73.6172H66V67.6172Z",
    fill: "#DEE9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67.6172H69V73.6172H74V67.6172Z",
    fill: "#DEE9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79 67.6172H76V73.6172H79V67.6172Z",
    fill: "#DEE9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 63.1886C24.4355 62.3207 25.1391 61.6172 26.007 61.6172H83.4022C84.2701 61.6172 84.9736 62.3207 84.9736 63.1886C84.9736 64.0565 84.2701 64.76 83.4022 64.76H26.007C25.1391 64.76 24.4355 64.0565 24.4355 63.1886Z",
    fill: "#DEE9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 37.0089C41 36.1411 41.7036 35.4375 42.5714 35.4375H83.9667C84.8346 35.4375 85.5381 36.1411 85.5381 37.0089V46.3882C85.5381 47.2561 84.8346 47.9596 83.9667 47.9596H42.5714C41.7036 47.9596 41 47.2561 41 46.3882V37.0089ZM44.1429 38.5804V44.8168H82.3952V38.5804H44.1429Z",
    fill: "#DEE9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1351 47.3179H27.8649C25.7838 47.3179 24 45.5341 24 43.453V40.1827C24 38.1017 25.7838 36.3179 27.8649 36.3179H31.1351C33.2162 36.3179 35 38.1017 35 40.1827V43.453C35 45.5341 33.5135 47.3179 31.1351 47.3179Z",
    fill: "#2DD68A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 42.2715C84.0593 42.2715 76 34.2124 76 24.2719C76 14.3306 84.0593 6.27148 94 6.27148C103.941 6.27148 112 14.3306 112 24.2719C112 34.2124 103.941 42.2715 94 42.2715Z",
    fill: "#00C66F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.74 19.03C103.426 19.8959 103.28 21.1538 102.414 21.8395L90.7066 31.1098C89.8424 31.7941 88.5873 31.6501 87.9006 30.7878L84.4356 26.4369C83.7475 25.5729 83.8901 24.3146 84.7541 23.6265C85.6182 22.9384 86.8764 23.081 87.5646 23.945L89.7871 26.7357L99.9304 18.7036C100.796 18.0179 102.054 18.164 102.74 19.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseComplete);
export default __webpack_public_path__ + "static/media/license-complete.499b702b13d842cb48b29c6ae2da7a9b.svg";
export { ForwardRef as ReactComponent };